import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'testimonial-ashley',
		path: '/testimonial/ashley-haugen-water-beads',
		component: loadable(async () => import(/* webpackChunkName: "pages/testimonial_ashley" */ './index'), {
			exportName: 'Testimonial',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
	},
];
